module.exports = __webpack_public_path__ + "static/reservando-0ba52795a7479e47924d863916c931af.png";